import { saveAs } from 'file-saver';
import docInvestmentExpenses from 'assets/documents/Δαπάνες Επένδυσης.xlsm';
import docCumulativeDeclaration from 'assets/documents/Υπόδειγμα_Υπεύθυνης_Δήλωσης_Σώρευσης.docx';
import docRealBeneficiaries from 'assets/documents/Υπόδειγμα_ΥΔ_Πραγματικών_Δικαιούχων.docx';

/**
 * Fetches a file from the given URL and triggers a download with the specified filename.
 * @param {string} url - The URL of the file to download.
 * @param {string} filename - The name to save the downloaded file as.
 */
const downloadFile = (url, filename) => {
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
      return response.blob();
    })
    .then(blob => {
      saveAs(blob, filename);
    })
    .catch(error => {
      console.error('Download error:', error);
      // Optionally: show user feedback about the error here
    });
};

export const content = (atomiki) =>
  [
    // Uncomment this if you want the investmentExpenses download link here as well
    // {
    //   label: (
    //     <span style={{ display: 'flex', flexDirection: 'row' }}>
    //       <span style={{ display: 'flex', alignItems: 'flex-start' }}>
    //         <b>Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"</b>
    //       </span>
    //       <span style={{ fontWeight: 'normal', fontSize: '11px', marginLeft: '5px' }}>
    //         (Κατεβάστε το υπόδειγμα{' '}
    //         <a
    //           style={{ textDecoration: 'underline', cursor: 'pointer' }}
    //           onClick={() => downloadFile(docInvestmentExpenses, 'Δαπάνες Επένδυσης.xlsm')}
    //           role="button"
    //           tabIndex={0}
    //           onKeyPress={(e) => {
    //             if (e.key === 'Enter' || e.key === ' ') downloadFile(docInvestmentExpenses, 'Δαπάνες Επένδυσης.xlsm');
    //           }}
    //         >
    //           εδώ
    //         </a>
    //         )
    //       </span>
    //     </span>
    //   ),
    //   fileCode: 'investmentExpenses',
    //   id: 'investmentExpenses',
    //   fileLimit: 10,
    //   required: true,
    // },
    {
      label: (
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
          <b>
            Υπεύθυνη Δήλωση Σώρευσης <span className="color-red">*</span>
          </b>
          <span style={{ fontWeight: 'normal', fontSize: '11px' }}>
            (Κατεβάστε το υπόδειγμα{' '}
            <a
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => downloadFile(docCumulativeDeclaration, 'Υπεύθυνη Δήλωση Σώρευσης.docx')}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') downloadFile(docCumulativeDeclaration, 'Υπεύθυνη Δήλωση Σώρευσης.docx');
              }}
            >
              εδώ
            </a>
            )
          </span>
        </span>
      ),
      fileCode: 'cumulativeDeclaration',
      id: 'cumulativeDeclaration',
      fileLimit: 10,
      // required: true,
    },
    {
      label: (
        <span>
          <b>Φορολογικό Έντυπο Ε3</b>
        </span>
      ),
      fileCode: 'taxFormE3',
      id: 'taxFormE3',
      fileLimit: 10,
      required: true,
    },
    {
      label: (
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
          <b>
            Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων <span className="color-red">*</span>
          </b>
          <span style={{ fontWeight: 'normal', fontSize: '11px' }}>
            (Κατεβάστε το υπόδειγμα{' '}
            <a
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => downloadFile(docRealBeneficiaries, 'Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων.docx')}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') downloadFile(docRealBeneficiaries, 'Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων.docx');
              }}
            >
              εδώ
            </a>
            )
          </span>
        </span>
      ),
      fileCode: 'realBeneficiariesDeclaration',
      id: 'realBeneficiariesDeclaration',
      fileLimit: 10,
      // required: true,
    },
    {
      label: (
        <span>
          <b>Eκτύπωση από το Κεντρικό Μητρώο Πραγματικών Δικαιούχων</b>
        </span>
      ),
      fileCode: 'beneficiariesRegistryPrint',
      id: 'beneficiariesRegistryPrint',
      fileLimit: 10,
      required: !atomiki,
    },
    {
      label: (
        <span>
          <b>Πιστοποιητικό Μεταβολών ΓΕΜΗ</b>
        </span>
      ),
      fileCode: 'gemiCertificate',
      id: 'gemiCertificate',
      fileLimit: 10,
      required: !atomiki,
    },
    {
      label: (
        <span>
          <b>Άλλα Δικαιολογητικά</b>
        </span>
      ),
      fileCode: 'otherDocuments',
      id: 'otherDocuments',
      fileLimit: 10,
      multiple: true,
      required: false,
    },
  ].filter(item => item);


  export const contentView = (atomiki) =>
    [
      {
        label: (
          <span style={{ display: 'flex', flexDirection: 'row' }}>
            <span style={{ display: 'flex', alignItems: 'flex-start' }}>
              <b>Συμπληρωμένο σε Ηλεκτρονική Μορφή Excel "Δαπάνες Επένδυσης"</b>
            </span>
          </span>
        ),
        fileCode: 'investmentExpenses',
        id: 'investmentExpenses',
        fileLimit: 10,
        required: true,
      },
      {
        label: (
          <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'left' }}>
            <b>Υπεύθυνη Δήλωση Σώρευσης</b>
          </span>
        ),
        fileCode: 'cumulativeDeclaration',
        id: 'cumulativeDeclaration',
        fileLimit: 10,
        required: true,
      },
      {
        label: (
          <span>
            <b>Φορολογικό Έντυπο Ε3</b>
          </span>
        ),
        fileCode: 'taxFormE3',
        id: 'taxFormE3',
        fileLimit: 10,
        required: true,
      },
      {
        label: (
          <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <b>Υπεύθυνη Δήλωση Στοιχείων Πραγματικών Δικαιούχων</b>
          </span>
        ),
        fileCode: 'realBeneficiariesDeclaration',
        id: 'realBeneficiariesDeclaration',
        fileLimit: 10,
        required: true,
      },
      {
        label: (
          <span>
            <b>Eκτύπωση από το Κεντρικό Μητρώο Πραγματικών Δικαιούχων</b>
          </span>
        ),
        fileCode: 'beneficiariesRegistryPrint',
        id: 'beneficiariesRegistryPrint',
        fileLimit: 10,
        required: !atomiki,
      },
      {
        label: (
          <span>
            <b>Πιστοποιητικό Μεταβολών ΓΕΜΗ</b>
          </span>
        ),
        fileCode: 'gemiCertificate',
        id: 'gemiCertificate',
        fileLimit: 10,
        required: !atomiki,
      },
      {
        label: (
          <span>
            <b>Άλλα Δικαιολογητικά</b>
          </span>
        ),
        fileCode: 'otherDocuments',
        id: 'otherDocuments',
        fileLimit: 10,
        multiple: true,
        required: false,
      },
    ].filter(item => item);